/**
 * Cabeçalho de página: título (28/600, tracking apertado), uma linha de contexto
 * e a ação da tela, alinhada pela base do título.
 * No celular a ação vai para baixo e ocupa a largura toda (seção 11).
 */
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** A ação da tela — no máximo UM botão `primary`. */
  action?: ReactNode;
  /** Mesmo papel de `action`, para vários botões lado a lado (nome usado no dump do design). */
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, action, actions, className }: PageHeaderProps) {
  const trailing = action ?? actions;

  return (
    <header
      className={cn(
        'mb-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between md:gap-4',
        className,
      )}
    >
      <div className="min-w-0 flex flex-col gap-1.5">
        <h1 className="text-xl font-semibold tracking-tight md:text-2xl">{title}</h1>
        {description ? (
          <p className="max-w-prose text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {trailing ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2 max-md:w-full [&>*]:max-md:w-full">
          {trailing}
        </div>
      ) : null}
    </header>
  );
}
